export type Project = {
  id: string;
  name: string;
  goal: string;
  stage: string;
  progress: number;
  nextStep: string;
  deadline: string;
  taskCount: number;
  status: 'active' | 'paused' | 'completed';
  updates: { date: string; content: string }[];
};

export const projects: Project[] = [
  {
    id: 'p1',
    name: '个人品牌内容计划',
    goal: '建立个人知识输出体系，每周稳定产出高质量内容',
    stage: '执行',
    progress: 65,
    nextStep: '完成本周选题与内容框架',
    deadline: '2026-09-30',
    taskCount: 4,
    status: 'active',
    updates: [
      { date: '2026-08-02', content: '完成上周内容数据复盘，阅读量较前周增长23%' },
      { date: '2026-07-30', content: '确定8月内容主题方向：个人效率、投资认知、旅行见闻' },
      { date: '2026-07-28', content: '完成网站关于页初版设计' },
    ],
  },
  {
    id: 'p2',
    name: '投资学习计划',
    goal: '建立系统性投资认知框架，掌握宏观分析与公司研究基本方法',
    stage: '执行',
    progress: 40,
    nextStep: '阅读宏观策略报告，理解当前市场核心矛盾',
    deadline: '2026-12-31',
    taskCount: 3,
    status: 'active',
    updates: [
      { date: '2026-08-01', content: '完成《投资最重要的事》读书笔记' },
      { date: '2026-07-25', content: '建立行业数据追踪表，覆盖消费、科技、新能源三大方向' },
    ],
  },
  {
    id: 'p3',
    name: '旅行规划',
    goal: '年底前完成一次深度旅行，兼顾放松和文化体验',
    stage: '规划',
    progress: 20,
    nextStep: '确定预算上限和时间窗口',
    deadline: '2026-11-15',
    taskCount: 2,
    status: 'active',
    updates: [
      { date: '2026-08-02', content: '初步列出候选目的地：东京、清迈、墨尔本' },
    ],
  },
  {
    id: 'p4',
    name: '健康管理计划',
    goal: '建立可持续的运动和饮食习惯，提升日常精力',
    stage: '等待',
    progress: 85,
    nextStep: '等待体检报告后调整训练计划',
    deadline: '2026-08-20',
    taskCount: 1,
    status: 'paused',
    updates: [
      { date: '2026-07-28', content: '完成第三季度体检' },
      { date: '2026-07-15', content: '连续12周保持每周4次训练' },
    ],
  },
  {
    id: 'p5',
    name: '家居整理优化',
    goal: '重新规划居家空间，提升在家工作和生活的舒适度',
    stage: '完成',
    progress: 100,
    nextStep: '',
    deadline: '2026-07-31',
    taskCount: 6,
    status: 'completed',
    updates: [
      { date: '2026-07-31', content: '全部空间整理完成，新布局使用一周反馈良好' },
      { date: '2026-07-20', content: '完成书房和客厅区域调整' },
    ],
  },
];
